export default __webpack_public_path__ + "static/media/logo.f13078c1.svg";